export default __webpack_public_path__ + "static/anuPrasad3-560bcda0180443ced4ffedb8d4d22545.jpg";